import React from 'react';

import {SettingIndentedRow} from '../components/SettingIndentedRow';
import {type MediaSetting} from './types';

/**
 * Renders subsettings with runtime content detection.
 *
 * Subsettings may be conditionally rendered based on inherited config values that we don't
 * have access to at filter time. This component renders all subsettings, then checks if any
 * actually rendered content (vs returning null), and hides the entire container if there's
 * no visible content.
 *
 * @param subsettings - Array of subsettings to render (pre-filtered by data-level shouldShow)
 */
export const Subsettings = ({subsettings}: {subsettings: MediaSetting[]}) => {
  // Don't render anything if there are no subsettings in the array
  if (subsettings.length === 0) {
    return null;
  }

  return (
    <SettingIndentedRow className="flex flex-col gap-8">
      <div>
        {subsettings.map(({component: SubSettingComponent}, index) => (
          // oxlint-disable-next-line react/no-array-index-key -- https://oxc.rs/docs/guide/usage/linter/rules/react/no-array-index-key.html
          <div className="subsetting-wrapper pl-12 leading-4" key={index}>
            <SubSettingComponent />
          </div>
        ))}
      </div>
    </SettingIndentedRow>
  );
};
